// Synthetic camera feed for desktop testing: ?demo=1 on the Scan page.
// Simulates paper invoices sliding into view, holding still, then being removed.
export function createDemoStream() {
  const canvas = document.createElement("canvas");
  canvas.width = 1280; canvas.height = 960;
  const ctx = canvas.getContext("2d");
  const start = performance.now();
  const CYCLE = 9000;

  const drawPaper = (x, y, w, h, title) => {
    ctx.fillStyle = "#f4f4f0";
    ctx.fillRect(x, y, w, h);
    ctx.fillStyle = "#1e293b";
    ctx.font = "bold 34px sans-serif";
    ctx.fillText(title, x + 40, y + 70);
    ctx.font = "22px sans-serif";
    ctx.fillText("Invoice No: INV-2045" + Math.round(y) % 100, x + 40, y + 120);
    ctx.fillText("Invoice Date: 14/06/2026", x + 40, y + 150);
    for (let i = 0; i < 9; i++) {
      const ly = y + 220 + i * 40;
      ctx.fillText(`10452${i}  CHKN BRST FLT FRESH 2X5KG    2   41.50   83.00`, x + 40, ly);
      ctx.fillRect(x + 40, ly + 10, w - 80, 1);
    }
  };

  const frame = () => {
    const t = (performance.now() - start) % CYCLE;
    ctx.fillStyle = "#2b2f36";
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    // subtle table texture
    ctx.fillStyle = "#33373f";
    for (let i = 0; i < 12; i++) ctx.fillRect(0, i * 80, canvas.width, 2);
    const w = 620, h = 760;
    if (t > 1200 && t < 6500) {
      const slide = Math.max(0, 1 - (t - 1200) / 900); // slide in over 0.9s
      const shake = t < 2600 ? Math.sin(t / 40) * 6 : 0;
      const gone = t > 5600 ? (t - 5600) / 900 : 0; // slide out
      const x = (canvas.width - w) / 2 + slide * 500 + shake - gone * 900;
      const y = (canvas.height - h) / 2 + shake * 0.5;
      drawPaper(x, y, w, h, "BIDFOOD");
    }
  };
  const timer = setInterval(frame, 66);
  frame();
  const stream = canvas.captureStream(15);
  const stop = stream.getTracks()[0].stop.bind(stream.getTracks()[0]);
  stream.getTracks()[0].stop = () => { clearInterval(timer); stop(); };
  return stream;
}
